import { c as _c } from "react/compiler-runtime";
import { HeaderTitle, NavigationHeader } from '@onefootprint/idv';
import { useTranslation } from 'react-i18next';
import useHandoffMachine from '../../hooks/use-handoff-machine';
const Canceled = () => {
  const $ = _c(10);
  const [state] = useHandoffMachine();
  const {
    opener
  } = state.context;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "pages.canceled"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <NavigationHeader />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t(_temp);
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== opener || $[5] !== t) {
    t3 = opener === "mobile" ? t(_temp2) : t(_temp3);
    $[4] = opener;
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="flex flex-col items-center justify-center h-full text-center"><div>{t1}<HeaderTitle title={t2} subtitle={t3} /></div></div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default Canceled;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.subtitle.mobile;
}
function _temp3($_1) {
  return $_1.subtitle.desktop;
}